var map = {
	"./Check-Circle-Fill.svg": "5165",
	"./Close.svg": "ad0f",
	"./Close2.svg": "347a",
	"./Collect.svg": "e983",
	"./Collected.svg": "9f22",
	"./Down.svg": "f30d",
	"./Upload.svg": "3938",
	"./adapt.svg": "7567",
	"./answer_layout_1.svg": "1390",
	"./answer_layout_2.svg": "0c08",
	"./answer_layout_3.svg": "c721",
	"./back.svg": "c557",
	"./book.svg": "6ac0",
	"./book_more.svg": "31ff",
	"./book_select.svg": "d0e6",
	"./book_xb.svg": "e334",
	"./book_xh.svg": "2cc6",
	"./calendar.svg": "0870",
	"./catalog-jia.svg": "76ea",
	"./catalog-jian.svg": "0468",
	"./constant_use_false.svg": "3872",
	"./constant_use_true.svg": "46b7",
	"./copy.svg": "19b6",
	"./cover.svg": "a186",
	"./delete.svg": "59a1",
	"./download.svg": "4daeb",
	"./edit.svg": "aa46",
	"./empty_nothing_img.svg": "830a",
	"./ic_Upload.svg": "50d4",
	"./ic_add_14_white.svg": "5fd1",
	"./ic_arrow2.svg": "0c41",
	"./ic_arrow_down.svg": "a334",
	"./ic_arrow_right_white.svg": "b50c",
	"./ic_chengjidan_16.svg": "e2ef",
	"./ic_cuoti_16.svg": "e73c",
	"./ic_datixiangqing.svg": "a81d",
	"./ic_down_20.svg": "d17f",
	"./ic_download.svg": "15b8",
	"./ic_edit.svg": "59aa",
	"./ic_editdetail.svg": "8d6e",
	"./ic_export_16.svg": "bd14",
	"./ic_exportrecord_16.svg": "1a8d",
	"./ic_folder.svg": "d72f",
	"./ic_img.svg": "d34f",
	"./ic_kaoshi.svg": "c80d",
	"./ic_kaoshi_blue.svg": "6b69",
	"./ic_kaoshi_white.svg": "0a47",
	"./ic_logout.svg": "3f7d",
	"./ic_minus_14.svg": "0477",
	"./ic_more.svg": "9d31",
	"./ic_new.svg": "76a0",
	"./ic_new_blue.svg": "399e",
	"./ic_pdf.svg": "61f9",
	"./ic_ppt.svg": "376d",
	"./ic_search.svg": "e8f9",
	"./ic_settings_20.svg": "5a45",
	"./ic_shalou.svg": "cce3",
	"./ic_share.svg": "8b71",
	"./ic_share_cancle.svg": "5337",
	"./ic_shijuan_16.svg": "cfa3",
	"./ic_shoppingcart_16.svg": "edf4",
	"./ic_suc_12.svg": "84c0",
	"./ic_suc_3.svg": "f695",
	"./ic_suc_60.svg": "888b",
	"./ic_testPaper.svg": "06ab",
	"./ic_transfer.svg": "249d",
	"./ic_up.svg": "b50f",
	"./ic_up_20.svg": "2170",
	"./ic_video.svg": "6be6",
	"./ic_weike.svg": "55e7",
	"./ic_word.svg": "7e03",
	"./ic_yinpin.svg": "2c51",
	"./ic_zuoye.svg": "d589",
	"./icon_bt.svg": "52fa",
	"./icon_lb.svg": "debf",
	"./index_detail.svg": "feba",
	"./index_kj.svg": "2a0e",
	"./index_more_red.svg": "65f1",
	"./index_play_red.svg": "2f82",
	"./index_play_white.svg": "9c35",
	"./index_sj.svg": "0755",
	"./index_szjc.svg": "b5f4",
	"./index_szzy.svg": "9e3b",
	"./index_yxjc.svg": "00ce",
	"./index_yxjs.svg": "8700",
	"./index_yxkl.svg": "f272",
	"./index_zhjx.svg": "6811",
	"./lable_books_jb.svg": "5462",
	"./lable_books_jp.svg": "03ea",
	"./lable_title_jp.svg": "41bd",
	"./lable_title_xh.svg": "9efd",
	"./more.svg": "3dd0",
	"./more_white.svg": "1f8e",
	"./move.svg": "2df4",
	"./order-down.svg": "29c9",
	"./order-nor.svg": "9cca",
	"./order-up.svg": "8b13",
	"./original.svg": "c8ad",
	"./pack.svg": "ff24",
	"./play.svg": "fb4f",
	"./save.svg": "0e55",
	"./screen1.svg": "8bdd",
	"./screen2.svg": "3559",
	"./sel_pc.svg": "d167",
	"./set.svg": "9873",
	"./share-cancel.svg": "64f2",
	"./share.svg": "5306",
	"./suc.svg": "26ef",
	"./top5.svg": "185a",
	"./tree-edit.svg": "5042",
	"./tree_add.svg": "5f6e",
	"./tree_add_sub.svg": "bd63",
	"./tree_remove.svg": "5dce",
	"./trophy-one.svg": "23ad",
	"./trophy-three.svg": "008b",
	"./trophy-two.svg": "7d92",
	"./type_img.svg": "31b2",
	"./type_pdf.svg": "c6ec",
	"./type_ppt.svg": "f249",
	"./type_video.svg": "be16",
	"./type_word.svg": "961a",
	"./unsel_pc.svg": "3bc4",
	"./weichat-logo.svg": "6929"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";